import { gql } from '@apollo/client'

const GET_GROUP_EVENTS = gql`
  query GetGroupEvents($orderBy: [GroupEventsOrderByInput!], $limit: Int) {
    currentUser {
      attributes {
        ... on Coach {
          canPromoteContent
        }
      }
      groupEvents(orderBy: $orderBy, limit: $limit) {
        __typename
        id
        startDateTime
        endDateTime
        registrationCloseDateTime
        tags
        timezone
        isCanceled
        title
        maxAttendance
        requiresAccessCode
        priceInCents
        featuredImageUrl
        slug
        isCanceled
        registrationCount
        description
        acceptsOnlinePayments
        externalRegistrationUrl
        seriesEndDateTime
        unlisted
        coachFacility {
          id
          name
        }
        coach {
          id
        }
        sessions {
          id
          startDateTime
          endDateTime
        }
        enrollments {
          id
          createdAt
          student {
            id
            firstName
            lastName
            representatives {
              contact {
                externalId
                firstName
                lastName
                phone
                email
              }
            }
            pgaHopeEmergencyContact {
              id
              firstName
              lastName
              phone
              email
              relationship
            }
            pgaHopeProfile {
              id
              accommodations
              additionalInfo
              golfCareerInterest
              golfExperience
              handedness
              hasOwnClubs
              militaryStatus
              referralSource
              serviceBranch
              serviceYearStart
              serviceYearEnd
              shirtSize
            }
          }
          transactions {
            amountInCents
            createdAt
            sourceType
            refund
            registrationPayment {
              id
            }
          }
          isCanceled
        }
      }
    }
  }
`
export default GET_GROUP_EVENTS
